<template>
  <v-container fluid class="pa-0 pt-4 scheduler-page">
    <v-row class="toolbar-row">
      <v-toolbar flat fixed class="default-toolbar">
        <v-btn
          @click="scrollNow"
          depressed
        >
          {{ lang.scheduler.now }}
        </v-btn>
        <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider>
        <div class="paginator_">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="190px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-on="on"
                v-bind="attrs"
                :value="formatDate(filters.date, false)"
                prepend-inner-icon="mdi-chevron-left-circle"
                append-icon="mdi-chevron-right-circle"
                @click:prepend-inner="pagDate(0)"
                @click:append="pagDate(1)"
                class="date-paginator"
                readonly
                solo
                hide-details
              />
            </template>
            <v-date-picker
              v-model="filters.date"
              locale="pt-br"
              no-title
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
        </div>
        <v-spacer></v-spacer>
        <v-slider
          v-model="options.schedule.width"
          min="75"
          max="399"
          append-icon="mdi-magnify-plus-outline"
          prepend-icon="mdi-magnify-minus-outline"
          class="my-2"
          style="max-width: 250px;"
          hide-details
        ></v-slider>
      </v-toolbar>
    </v-row>
    <v-row class="scheduler-row">
      <v-container class="scheduler">
        <v-row class="pa-0 ma-0">
          <v-col cols="1" class="pa-0 scheduler-groups">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>
                      <v-icon small class="employee-icon">{{ lang.users.icon }}</v-icon>
                      {{ lang.users.view.user }}
                    </th>
                    <th
                      @click="scroll_(0)"
                      @dblclick.stop="scroll_(0, true)"
                      @mousedown="scrollHold(0, true)"
                      @mouseleave="scrollHold(0)"
                      @mouseup="scrollHold(0)"
                      @touchstart="scrollHold(0, true)"
                      @touchend="scrollHold(0)"
                      @touchcancel="scrollHold(0)"
                      class="scheduler-slider-btn"
                    >
                      <v-btn
                        icon
                        small
                        color="grey lighten-1"
                      >
                        <v-icon>mdi-chevron-left</v-icon>
                      </v-btn>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(employee, i) in data"
                    :key="i"
                  >
                    <td colspan="2" :style="(employee.lines > 0 ? `height: ${(employee.lines * 48)}px !important;` : '')">
                      <Employee :value="employee" noSpacing />
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col cols="10" class="pa-0 scheduler-schedules">
            <v-container
              v-dragscroll.x="{ target: '.v-data-table__wrapper', active: true }"
              class="pa-0 ma-0 schedules-container"
            >
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th :style="{ 'min-width': '15px' }" show-fractions="hideall"> </th>
                      <th
                        v-for="(h, i) in 24"
                        :key="i"
                        :data-hour="i"
                        :class="{ now: (filters.date === getDate_(false) && hour.now === i) }"
                        :style="{ 'min-width': `${options.schedule.width}px` }"
                        :show-fractions="(options.schedule.width < 144 ? (options.schedule.width < 77 ? 'hideall' : 'hidequarter') : 'showall')"
                      >
                        <span :data-hour="i">{{ `${i}:00` }}</span>
                      </th>
                      <th :style="{ 'min-width': '15px' }" show-fractions="hideall"> </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="({ schedules, lines }, i) in data"
                      :key="i"
                    >
                      <td></td>
                      <td
                        v-for="(h, i_) in 24"
                        :key="i_"
                        :class="{ now: (filters.date === getDate_(false) && hour.now === i_) }"
                        :style="(lines > 0 ? `height: ${(lines * 39)}px !important;` : '')"
                      >
                        <Schedules
                          :value="getSchedules(schedules, i_)"
                          @view="$emit('view', $event)"
                          @edit="$emit('edit', $event)"
                        />
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-container>
          </v-col>
          <v-col class="pa-0 scheduler-slider-btn">
            <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr
                      @click="scroll_(1)"
                      @dblclick.stop="scroll_(1, true)"
                      @mousedown="scrollHold(1, true)"
                      @mouseleave="scrollHold(1)"
                      @mouseup="scrollHold(1)"
                      @touchstart="scrollHold(1, true)"
                      @touchend="scrollHold(1)"
                      @touchcancel="scrollHold(1)"
                    >
                      <th>
                        <v-btn
                          icon
                          small
                          color="grey lighten-1"
                        >
                          <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                      </th>
                    </tr>
                  </thead>
                </template>
              </v-simple-table>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
  </v-container>
</template>

<script>
import Employee from './templates/Employee'
import Schedules from './templates/Schedules'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import { DEFAULT_DATE } from '@/components/utils/daterange/constants'
import { format, addDays, subDays } from 'date-fns'
import { Launches } from '../modules/launches.js'

export default {
  components: { Employee, Schedules },
  mixins: [ appdata, utils ],
  data () {
    return {
      menu: false,
      options: {
        schedule: {
          width: 228
        }
      },
      hour: {
        now: 0,
        interval: false,
        firstChange: true
      },
      scroll: {
        interval: false
      },
      filters: {
        date: DEFAULT_DATE
      }
    }
  },
  computed: {
    data () {
      this.filters
      this.get_data.schedules
      let employees = (typeof this.permissions.scheduler.only_me !== 'undefined' && this.permissions.scheduler.only_me ? (this.get_data.employees || []).filter(emp => emp.id === this.user_data.id) : this.get_data.employees || []),
          schedules = ((this.get_data.schedules || {}).all || []).map(sch => ({ ...sch, color: this.getRandomColor() })),
          launches = new Launches(
            schedules,
            employees || [],
            this.filters || {}
          )
      return launches.get() || []
    }
  },
  watch: {
    'hour.now' () {
      this.scrollNow()
      this.firstChange = false
    }
  },
  methods: {
    hour_ () {
      if (!this.hour.interval) {
        this.hour.interval = setInterval(function () {
          let now = (new Date()).getHours()
          if (this.hour.now !== now) this.hour.now = now
        }.bind(this), 355)
      }
    },
    scrollHold (direction, hold = false) {
      if (hold) {
        if (!this.scroll.interval) {
          this.scroll.interval = setInterval(function () {
            this.scroll_(direction)
          }.bind(this), 200)
        }
      } else {
        clearInterval(this.scroll.interval)
        this.scroll.interval = false
      }
    },
    scroll_ (direction, full = false) {
      const el = this.$el.querySelector('.schedules-container .v-data-table__wrapper')
      let scroll = (full ? (this.options.schedule.width * 2) * 2500 : (this.options.schedule.width * 2))
      el.scroll(
        {
          top: 0,
          left: (direction > 0 ? el.scrollLeft + scroll : el.scrollLeft - scroll),
          behavior: 'smooth'
        }
      )
    },
    scrollNow () {
      this.filters.date = this.getDate_(false)
      this.$nextTick(() => {
        let now = this.$el.querySelector('.schedules-container .v-data-table__wrapper thead tr .now')
        if (now) now.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
      })
    },
    getSchedules (schedules, hour) {
      return schedules.filter(e => parseInt((new Date(e._start)).getHours()) === hour) || []
    },
    pagDate (action) {
      let date = this.filters.date,
          newDate = (action > 0 ? addDays(new Date(Date.parse(date.replace('-','/','g'))), 1) : subDays(new Date(Date.parse(date.replace('-','/','g'))), 1))
      this.filters.date = format(newDate, 'yyyy-MM-dd')
      return true
    }
  },
  mounted () {
    this.hour_()
  }
}
</script>

<style src="./styles/index.scss" lang="scss" />
